import { Injectable, onModuleInit } from '@tokamakjs/injection';

import { bootstrap } from '~/bootstrap';

@Injectable()
export class AppService {
  @onModuleInit()
  bootstrap() {
    return bootstrap();
  }
}
